import actions from './actions'

const initState = {
    listUser: [],
    PageNumber: 0,
    listMsg: [],
    crrUser: [],
    lstReply: [],
    isloading: false,
    isloadingMess: false,
    totalMessage: 0,
    receiverInfo: [],
    listCrrOrg: null,
    listReplyInReply: [],
}
function setData(data, dataReply){
    let isHave = data.findIndex(vl =>{
        return vl.key === dataReply.key
    })
    console.log('ishave', isHave)
    if(isHave !== -1){
        data[isHave] = dataReply
        console.log('data is have', data[isHave])
        return data
    }else{
        data = data.concat(dataReply)
        return data
    }
}

const QMreducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.GET_REPLY_IN_REPLY_DONE:
            let crrReply = {
                key: action.payload.reply_id,
                value: action.payload.data
            }
            let data = setData(state.listReplyInReply, crrReply)
            return {
                ...state,
                ...{
                    listReplyInReply: [...data]
                }
            }
        case actions.type.GET_CURRENT_LIST_ORG_DONE:
            return {
                ...state,
                ...{
                    listCrrOrg: action.payload.data
                }
            }
        case actions.type.GET_INFO_UID_RECEIVER:
            return {
                ...state,
                ...{
                    isloading: true,
                },
            }
        case actions.type.GET_INFO_UID_RECEIVER_DONE:
            return {
                ...state,
                ...{
                    receiverInfo: action.payload.data,
                    isloading: false,
                },
            }
        case actions.type.UPDATE_IS_LOAADING_MESS:
            return {
                ...state,
                ...{
                    isloadingMess: action.payload.bool,
                },
            }
        case actions.type.GET_LIST_REPLY_IN_MESSAGE:
            return {
                ...state,
                ...{
                    isloading: true,
                },
            }
        case actions.type.GET_LIST_REPLY_IN_MESSAGE_DONE:
            return {
                ...state,
                ...{
                    lstReply: action.payload.data,
                    isloading: false,
                },
            }
        case actions.type.UPDATE_CURRENT_USER:
            return {
                ...state,
                ...{
                    crrUser: action.payload.data,
                },
            }
        case actions.type.GET_LIST_MESSAGE:
            return {
                ...state,
                ...{
                    PageNumber: action.payload.page_number,
                },
            }
        case actions.type.GET_LIST_MESSAGE_DONE:
            return {
                ...state,
                ...{
                    listMsg: action.payload.isloadmore ? state.listMsg.concat(action.payload.data.data) : action.payload.data.data,
                    totalMessage: action.payload.data.total,
                },
            }
        case actions.type.GET_LIST_USER_BY_TEXT_DONE:
            console.log('action.payload.data', action.payload.data)
            return {
                ...state,
                ...{
                    listUser: action.payload.data,
                },
            }

        default:
            return state
    }
}

export default QMreducer
